import React from "react";
import InfoBox from "../InfoBox";

interface GalleryHeaderProps {
  infoText?: string;
}

const GalleryHeader = (props: GalleryHeaderProps) => {
  const { infoText } = props;
  return infoText ? (
    <InfoBox compress text={infoText}>
      <h3>Attachments</h3>
    </InfoBox>
  ) : (
    <h3>Attachments</h3>
  );
};

export default GalleryHeader;
